import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import axios from 'axios';

const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num;
};

const VisitorStats = () => {
    const [today,setToday] = useState(0);
    const [week,setWeek] = useState(0);
    const [month,setMonth] = useState(0);
    const [overall,setOverall] = useState(0);
    const fetchVisitors = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/visits/stats`);
            const data = response.data; // Use `response.data` directly for axios
            if (data.success) {
                // setStats(data.stats);
                setToday(data.stats.today);
                setWeek(data.stats.week);
                setMonth(data.stats.month);
                setOverall(data.stats.overall);
            } else {
                // setError('Failed to fetch stats');
            }
        } catch (err) {
            // setError('Error fetching stats');
        } finally {
            // setLoading(false); // Ensure loading is set to false regardless of success or failure
        }
    };

    useEffect(() => {
        fetchVisitors();
    }, []);
    // console.log(today, week, month, overall);
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                padding: 2,
                gap: 3,
            }}
        >
            {[
                { label: 'Today', value: today, gradient: 'linear-gradient(135deg, #4a90e2, #0056b3)' }, // Blue Gradient
                { label: 'This week', value: week, gradient: 'linear-gradient(135deg, #bdba2d, #958b14)' }, // Orange Gradient
                { label: 'This month', value: month, gradient: 'linear-gradient(135deg, #2ecc71, #27ae60)' }, // Green Gradient
                { label: 'Overall', value: overall, gradient: 'linear-gradient(135deg, #9b59b6, #8e44ad)' }, // Purple Gradient
            ].map(({ label, value, gradient }) => (
                <Box
                    key={label}
                    sx={{
                        flex: 1,
                        textAlign: 'center',
                        padding: 2,
                        borderRadius: 2,
                        background: gradient,
                        color: '#ffffff',
                        boxShadow: 3,
                        minWidth: 150, // Optional: Set a minimum width for responsiveness
                    }}
                >
                    <Typography variant="h6">{label}</Typography>
                    <Typography variant="h4">{formatNumber(value)}</Typography>
                </Box>
            ))}
        </Box>
    );
};

export default VisitorStats;
